import rootStyle from '../../../rootStyles/rootStyles.module.css'
import style from './Content.module.css'

const Content = () => {
    return (
        <div className={rootStyle.centerContent}>
            <div className={style.center}>
                <div className={style.fived}>
                    <div className={style.ford}>
                        <div className={style.thrid}>
                            <div className={style.second}>
                                <div className={style.first}>
                                    <div><i className="fas fa-store"></i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Content